import { emailFeaturesComputer, fieldFeaturesComputer, otpFeaturesComputer, passwordFeaturesComputer, usernameFeaturesComputer, usernameHiddenFeaturesComputer } from "@protontech/autofill/features/v1/fields.sorted.gen";
import { formFeaturesComputer } from "@protontech/autofill/features/v1/forms.sorted.gen";

export const featureProvider = {
  // base
  field: fieldFeaturesComputer,
  form: formFeaturesComputer,
  // fields
  email: emailFeaturesComputer,
  "new-password": passwordFeaturesComputer,
  otp: otpFeaturesComputer,
  password: passwordFeaturesComputer,
  username: usernameFeaturesComputer,
  "username-hidden": usernameHiddenFeaturesComputer,
  // forms
  login: formFeaturesComputer,
  recovery: formFeaturesComputer,
  register: formFeaturesComputer,
  "password-change": formFeaturesComputer,
};

export type FeatureProvider = typeof featureProvider;
